import { DataBean } from "../../DataBean";


export class RestartFixedAsset extends DataBean {

    public async restartFixedAssetConsecutivesFrom(year: any, fromConsecutive: any, newConsecutive: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "boolean_restartFixedAssetConsecutivesFrom_Number_Number_Number", [year, fromConsecutive, newConsecutive]);
    }

}